import { Button } from '@ui/components';
import { CirclePlusIcon } from 'lucide-react';
import { FC } from 'react';

interface NewButtonProps {
  onAddNew: () => void;
}

export const NewButton: FC<NewButtonProps> = (props) => {
  const { onAddNew } = props;
  return (
    <Button
      className="h-10"
      onClick={onAddNew}
    >
      <CirclePlusIcon className="mr-2 size-4" />
      New
    </Button>
  );
};
